import {
  getAutoLoanOffer,
  getCreditCardOffer,
  getHomeLoanOffer,
  getPersonalLoanOffer,
} from '../helpers/availableForYou.helper';

export const useAvailableForYou = ({ todayContainerModules }) => {
  const creditCardOfferMetaData = todayContainerModules.find(
    module => module.module === 'Suggested Credit Card',
  )?.offers?.[0];

  const offersCards = [
    getCreditCardOffer(todayContainerModules),
    getPersonalLoanOffer(todayContainerModules),
    getAutoLoanOffer(todayContainerModules),
    getHomeLoanOffer(),
  ].filter(offer => offer !== null);

  return {
    creditCardOfferMetaData,
    offersCards,
  };
};
